export const ta = {
    LEFT: 'இடது: நடவடிக்கை, முந்தைய நாள்.',
    RIGHT: 'வலது: செல்ல அடுத்த நாள்.',
    DOWN: 'கீழே: அடுத்த செல்ல வரிசையில்.',
    UP: 'வரை: நடவடிக்கை, முந்தைய வரிசையில்.',
    PGUP: 'PgUp: நடவடிக்கை, முந்தைய மாதம்.',
    PGDOWN: 'PgDown: நடவடிக்கை, அடுத்த மாதம்.',
    HOME: 'வீட்டில்: நடவடிக்கை, முந்தைய ஆண்டு.',
    END: 'இறுதியில்: நடவடிக்கை, அடுத்த ஆண்டு.',
    ESC: 'Esc/இன்று/Close: மூடவும் காலண்டர்.',
    TITLE: 'Keyboard வழிமுறைகள்'
};
